import { PERSONAL_CODE_LENGTH } from "common/constants";
import { BANK_ACCOUNT_NUMBER_REGEX_PATTERN, EMAIL_REGEX_EXPRESSION, INVALID_EMAIL_DOMAIN_REGEX_EXPRESSION } from "common/constants/regex";

export const isValidEmail = (email: string) => {
    if(INVALID_EMAIL_DOMAIN_REGEX_EXPRESSION.test(email)) return false;
  
    return EMAIL_REGEX_EXPRESSION.test(email);
}
  
export const isEmailValidAndPresent = (email?: string) => {
    if(!email) return false;
    return isValidEmail(email.trim());
}

export const isValidCommaSeperatedEmail = (email: string) => {
    return email.split(",").every(email => isValidEmail(email.trim()));
}

export const validateBankAccountNumber = (bankAccountNumber: string) => {
    return new RegExp(BANK_ACCOUNT_NUMBER_REGEX_PATTERN).test(bankAccountNumber);
}


const checkOne = (chars: number[]): number => {
    return (
        chars[0] +
        chars[1] * 2 +
        chars[2] * 3 +
        chars[3] * 4 +
        chars[4] * 5 +
        chars[5] * 6 +
        chars[6] * 7 +
        chars[7] * 8 +
        chars[8] * 9 +
        chars[9]
    ) % 11;
};

const checkTwo = (chars: number[]): number => {
    return (
        chars[0] * 3 +
        chars[1] * 4 +
        chars[2] * 5 +
        chars[3] * 6 +
        chars[4] * 7 +
        chars[5] * 8 +
        chars[6] * 9 +
        chars[7] +
        chars[8] * 2 +
        chars[9] * 3
    ) % 11;
};

export const isPersonCode = (idCode?: string) => {
    const idCodeLength = PERSONAL_CODE_LENGTH;

    if (idCode?.length !== idCodeLength) {
        return false;
    }

    const chars: number[] = [];

    for (let i = 0; i < idCode.length; i++) {
        const char = idCode[i];

        if (isNaN(Number(char))) {
            return false;
        }

        chars.push(Number(char));
    }

    if (
        (checkOne(chars) !== 10 && checkOne(chars) === chars[10]) ||
        (checkTwo(chars) !== 10 && checkTwo(chars) === chars[10]) ||
        (checkTwo(chars) === 10 && chars[10] === 0)
    ) {
            return true;
        }
    
    return false;
};

export const isPhoneNumber = (phoneNumber: string) => {
    const regex = /^5\d{6,7}$/;
    return regex.test(phoneNumber);
};